import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngxs/store';
import {Account} from '../../models/accounts/account.model';
import {AccountsState} from '../../state/accounts.state';

@Pipe({
  standalone: false,
  name: 'creditor'
})
export class CreditorResolvePipe implements PipeTransform {
  private readonly creditors: Account[];

  constructor(private store: Store) {
    this.creditors = this.store.selectSnapshot(AccountsState.creditors);
  }

  transform(value: any): string {
    if (value === null || value === undefined || value === '' || this.creditors?.length === 0) {
      return 'Creditor not found!';
    }
    const creditor = this.creditors.find(c => c.id === value);
    return creditor ? creditor.name : 'Creditor not found!';
  }

}
